import { useLocation } from 'react-router-dom';

import { ROUTES } from 'consts';
import { useParamValues } from 'hooks/url.hook';
import { useAppSelector } from 'store/store.hook';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';

export const useActiveLink = () => {
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);
  const location = useLocation();
  const pathname = location.pathname.replace(`/${orgSlug}/`, '');
  const { buildingId = '' } = useParamValues(['buildingId']);

  let activeLink = pathname;

  if (pathname === `${ROUTES.DASHBOARD}${buildingId ? '/' : ''}${buildingId}`) {
    activeLink = ROUTES.DASHBOARD;
  } else if (
    pathname === ROUTES.BUILDING_CREATE ||
    pathname === `${ROUTES.BUILDINGS}/${buildingId}/${ROUTES.ZONES_ACTIVE}` ||
    pathname === `${ROUTES.BUILDINGS}/${buildingId}/${ROUTES.ZONES_INACTIVE}`
  ) {
    activeLink = ROUTES.BUILDINGS;
  } else if (
    pathname === `${ROUTES.ZONES}/${ROUTES.ZONES_ACTIVE}` ||
    pathname === `${ROUTES.ZONES}/${ROUTES.ZONES_INACTIVE}`
  ) {
    activeLink = ROUTES.ZONES;
  }

  return { activeLink };
};
